import { ReactNode } from 'react';
// @mui
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
//
import { STAGE, TYPE } from '../../../theme/stage';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  align?: 'left' | 'center';
  sx?: SxProps<Theme>;
};

export default function Eyebrow({ children, align, sx }: Props) {
  return (
    <Box
      component="p"
      sx={[
        {
          ...TYPE.label,
          m: { xs: '0 0 12px', sm: '0 0 16px' },
          color: STAGE.mute,
          textAlign: align,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
